import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class RemoveTenantLeaseError extends CodedError {
  static get errorName() {
    return errorCodeTypes.removeTenantLeaseError.code;
  }

  constructor(message = errorCodeTypes.removeTenantLeaseError.message) {
    super(message);
    this.code = errorCodeTypes.removeTenantLeaseError.code;
    this.message = `${message} ${errorCodeTypes.removeTenantLeaseError.code}`;
    this.name = errorCodeTypes.removeTenantLeaseError.name;
  }
}
